import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CampaignEventStatus } from '@brightside-web/shared/display';
import { Campaign } from '@brightside-web/desktop/data-access/shared';
import { BsChatService, routePath } from '@brightside-web/desktop/data-access/core-services';
import {
  DisplayCampaignEvent,
  SharedDisplayCampaignComponent,
  SharedDisplayModule
} from '@brightside-web/shared/display';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { SurveyQuestionnaireService } from '../survey-questionnaire.service';

@Component({
    selector: 'brightside-web-survey-info-view',
    templateUrl: './survey-info-view.component.html',
    styleUrls: ['./survey-info-view.component.scss'],
    imports: [BrightsideUiModule, SharedDisplayModule]
})
export class SurveyInfoViewComponent {
  campaign: Campaign = {
    key: 'survey-emoney-info',
    titleKey: 'SURVEY_EMONEY_INFO_TITLE',
    image: 'emergency_support',
    textBodyKey: 'SURVEY_EMONEY_INFO_DESC',
    textBodyAlign: 'left',
    textBodyNoWrap: true,
    ctaKey: 'MESSAGE_FA',
    secondaryCtaPath: '',
    secondaryCta: '',
    ctaPath: '',
    listSubHeader: 'HOW_IT_WORKS',
    listItems: ['SURVEY_EMONEY_INFO_MARK1', 'SURVEY_EMONEY_INFO_MARK2', 'SURVEY_EMONEY_INFO_MARK3'],
    alignContentToCenter: false,
  };

  private _router: Router = inject(Router);
  private _bsChatService: BsChatService = inject(BsChatService);
  private _surveyQuestionnaireService = inject(SurveyQuestionnaireService);

  handleCampaignEvent($event: DisplayCampaignEvent) {
    if ($event.type === CampaignEventStatus.FAILED) {
      this._surveyQuestionnaireService.backToHomeCalled();
    } else {
      this._bsChatService.showChat();
    }
  }
}
